var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartBenchmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-chart-column w-6 h-6",
    "aria-hidden": "true",
    "data-fg-b7rw7": ":149.260:/App.tsx:13:17:639:44:e:BarChart3::::::C2Ja",
    "data-fgid-b7rw7": ":r6:",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v16a2 2 0 0 0 2 2h16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17V9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17V5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17v-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartBenchmark);
export default __webpack_public_path__ + "static/media/smart-benchmark.ebec50a9f88ca747e23ecacb5ac9010e.svg";
export { ForwardRef as ReactComponent };